'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class;

var _reactIntl = require('react-intl');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _components2 = require('components');

var _forms = require('metadata/forms');

var _pacomo = require('utils/pacomo');

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

require('react-datepicker/dist/react-datepicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    DatetimeInput: {
        displayName: 'DatetimeInput'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/DatetimeInput.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var DatetimeInput = _wrapComponent('DatetimeInput')((0, _reactIntl.injectIntl)(_class = (0, _pacomo.pacomoDecorator)(_class = function (_Component) {
    (0, _inherits3.default)(DatetimeInput, _Component);

    function DatetimeInput(props) {
        (0, _classCallCheck3.default)(this, DatetimeInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DatetimeInput.__proto__ || (0, _getPrototypeOf2.default)(DatetimeInput)).call(this, props));

        _this.handleChange = function (date) {
            if (date && (0, _moment2.default)(date).isValid()) {
                _this.props.input.onChange((0, _moment2.default)(date).format('YYYY-MM-DDTHH:mm:00'));
            } else {
                _this.props.input.onChange('');
            }
        };

        return _this;
    }

    (0, _createClass3.default)(DatetimeInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                intl = _props.intl,
                input = _props.input,
                id = _props.id,
                requirement = _props.requirement,
                _props$meta = _props.meta,
                touched = _props$meta.touched,
                error = _props$meta.error,
                rest = (0, _objectWithoutProperties3.default)(_props, ['intl', 'input', 'id', 'requirement', 'meta']);

            var isClearable = requirement && requirement.editable;
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'label',
                    { htmlFor: id },
                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'datetimeInputLabel',
                        defaultMessage: 'Select Date and Time'
                    })
                ),
                _react3.default.createElement(_reactDatepicker2.default, (0, _extends3.default)({}, rest, {
                    dateFormat: 'YYYY-MM-DD HH:mm',
                    selected: input.value ? (0, _moment2.default)(input.value) : null,
                    showTimeSelect: true,
                    timeFormat: 'HH:mm',
                    timeIntervals: 15,
                    isClearable: isClearable,
                    onChange: this.handleChange,
                    disabled: requirement && !requirement.editable
                })),
                _react3.default.createElement(_components2.FieldHelpErrorText, { touched: touched, error: error })
            );
        }
    }]);
    return DatetimeInput;
}(_react2.Component)) || _class) || _class);

exports.default = DatetimeInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/DatetimeInput.js
// module id = 1341
// module chunks = 0